import C from "@constants/constants";

const getPayloadSizeInKB = (payload: unknown) => {
  try {
    const jsonString = JSON.stringify(payload);
    const sizeInBytes = new TextEncoder().encode(jsonString).length;
    return sizeInBytes / 1024; // convert bytes to kilobytes
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error("Error calculating payload size:", error);
  }
};

const chunkArrayInKB = <T>(array: T[], maxSizeInKB = C.MAX_REQUEST_BODY_SIZE_KB) => {
  const chunks: T[][] = [];
  let chunk: T[] = [];

  for (const item of array) {
    chunk.push(item);
    const chunkSizeInKB = getPayloadSizeInKB(chunk);
    if (chunkSizeInKB && chunkSizeInKB > maxSizeInKB) {
      chunk.pop();
      chunks.push(chunk);
      chunk = [item];
    }
  }

  if (chunk.length > 0) {
    chunks.push(chunk);
  }

  return chunks;
};

export default chunkArrayInKB;
